import { reconcileBrand } from "./brandState";
import { isAutomatic } from "./cache";
/** Serialise apply runs: a trigger while one is in flight queues exactly one
 *  more run, which re-reads the pane state when it starts. */
export function createApplyRunner(run) {
    let inFlight = false;
    let again = false;
    const trigger = async () => {
        if (inFlight) {
            again = true;
            return;
        }
        inFlight = true;
        try {
            await run();
        }
        finally {
            inFlight = false;
            if (again) {
                again = false;
                void trigger();
            }
        }
    };
    return trigger;
}
/** Fetch the signature for the pane's current choices and fold the reply back
 *  into `state`. The request options are snapshotted once, before any await,
 *  and both the cache tag and the reconciliation use that snapshot, so a pane
 *  click during SSO can neither be tagged automatic nor overwritten by the
 *  older reply. Throws if the fetch fails. */
export async function fetchAndReconcile(state, overrides, fromAddress, deps) {
    const opts = {
        fromAddress,
        brandOverride: state.selectedBrand ?? undefined,
        ...(state.isAdmin
            ? {
                forceMhfa: state.forceMhfa,
                forceDisclaimer: state.forceDisclaimer,
                forceTuv: state.forceTuv,
            }
            : {}),
        ...overrides,
    };
    const automatic = isAutomatic(opts);
    const token = await deps.getToken();
    const payload = await deps.fetchSignature(token, opts);
    const next = reconcileBrand(state.selectedBrand, opts.brandOverride ?? null, payload.brand.shortName);
    state.selectedBrand = next.selected;
    if (next.auto !== undefined)
        state.autoBrand = next.auto;
    return { payload, automatic };
}
